export default "__VITE_ASSET__CiMnBbgi__"